
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">
              {t('company.name')}
            </h3>
            <p className="text-gray-300 mb-4">
              {t(
                'company.description',
                'Leading Malaysian palm oil specialist providing quality products and services to global markets.'
              )}
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-gray-300 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              {t('footer.quickLinks', 'Quick Links')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.products')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              {t('footer.services', 'Services')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/certifications"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.certifications')}
                </Link>
              </li>
              <li>
                <Link
                  to="/partnerships"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.partnerships')}
                </Link>
              </li>
              <li>
                <Link
                  to="/quote"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.quote')}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              {t('footer.contact', 'Contact Info')}
            </h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-yellow-400 mt-1"></i>
                <p className="text-gray-300">
                  No 13, Persiaran Andalas 1, Kawasan Perindustrian Sinar
                  Andalas, 70450 Seremban, Negeri Sembilan, Malaysia
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-yellow-400"></i>
                <p className="text-gray-300">+60 12-235 3795</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-whatsapp-line text-yellow-400"></i>
                <a
                  href="https://wa.me/60122353795"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  WhatsApp: +60 12-235 3795
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-yellow-400"></i>
                <p className="text-gray-300">sales@drixemgroup.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} {t('company.name')}.{' '}
              {t('footer.allRights', 'All rights reserved.')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
